const claimedSsoAuthorizationCodes = new Set<string>();

/**
 * Claims a one-time WorkOS authorization code for exchange.
 * Returns false when the code was already claimed, so a remount cannot
 * start a second `/v1/scorpius/sso/authorize` call with the same code.
 */
export function claimSsoAuthorizationCode(code: string): boolean {
  if (claimedSsoAuthorizationCodes.has(code)) {
    return false;
  }

  claimedSsoAuthorizationCodes.add(code);
  return true;
}

/**
 * Clears claimed codes. Intended for unit tests only.
 */
export function resetClaimedSsoAuthorizationCodes(): void {
  claimedSsoAuthorizationCodes.clear();
}
